import React, { useState } from "react";

export default function Disclaimer() {
  const [isAccepted, setIsAccepted] = useState(false);
  const [expanded, setExpanded] = useState(false);

  // Handle acceptance
  const handleAccept = () => {
    setIsAccepted(true);
  };

  // Toggle Read More
  const toggleReadMore = () => {
    setExpanded(!expanded);
  };

  if (isAccepted) return null; // Hide disclaimer after acceptance

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center p-4 z-50">
      <div className="bg-white max-w-lg w-full p-6 rounded-lg shadow-lg text-center max-h-[90vh] overflow-y-auto">
        {/* Title */}
        <h2 className="text-2xl font-bold text-[#0F172A]">Legal Disclaimer</h2>

        {/* Content Container */}
        <div className="mt-4 text-sm text-justify leading-relaxed text-gray-600">
          <p>
            The current rules of the Bar Council of India impose restrictions on maintaining a web page and do not permit lawyers to provide information concerning their areas of practice.
            <b> Anil Dhyani & Associates Law Offices </b> is, therefore, constrained from providing any further information on this web page.
          </p>

          {!expanded && (
            <p className="mt-3">
              The rules prohibit law firms from soliciting work or advertising in any manner.{" "}
              <button
                className="text-[#C9A227] font-semibold underline focus:outline-none"
                onClick={toggleReadMore}
              >
                Read More...
              </button>
            </p>
          )}

          {expanded && (
            <>
              <p className="mt-3">
                By clicking on <b>‘I AGREE’</b>, the user acknowledges that:
              </p>

              {/* List of Acknowledgments */}
              <ul className="mt-3 list-decimal list-inside">
                <li>
                  The user wishes to gain more information about <b>Anil Dhyani & Associates Law Offices India</b>, its practice areas, and its attorneys for his/her own information and use.
                </li>
                <li>
                  The information is made available to the user only upon his/her specific request, and any material downloaded from this website is completely at the user’s volition. Any transmission, receipt, or use of this site is not intended to create any lawyer-client relationship.
                </li>
                <li>None of the information on this website constitutes a legal opinion or amounts to legal advice.</li>
                <li>
                  <b>Anil Dhyani & Associates Law Offices India</b> is not liable for any consequences arising from any action taken by the user relying on material/information provided on this website. Users must seek independent legal advice for any legal issues.
                </li>
              </ul>

              {/* Show Less Button */}
              <button
                className="mt-3 text-[#C9A227] font-semibold underline focus:outline-none"
                onClick={toggleReadMore}
              >
                Show Less
              </button>
            </>
          )}
        </div>

        {/* Accept Button */}
        <button
          className="mt-6 px-6 py-2 bg-[#C9A227] text-[#0F172A] font-semibold rounded-lg hover:bg-[#B79527] transition duration-300"
          onClick={handleAccept}
        >
          I Agree
        </button>
      </div>
    </div>
  );
}
